import React, { FunctionComponent, useContext } from 'react';
import { AccountPage } from './AccountPage';
import { AccountPage2 } from './AccountPage2';
import { AuthStore } from '../../context';

/*
 * This component is intended to support the bypass of 'fattmerchant' brand types.
 * This is a short-term experiment - to be deleted as soon as business KPIs have deemed it so.
 * Hans H. Oct 24, 2021
 */
export const AccountPageSwitcher: FunctionComponent = () => {
  const {
    state: { auth },
  } = useContext(AuthStore);

  return auth?.brand === 'fattmerchant' ? <AccountPage2 /> : <AccountPage />;
};
